'use strict';

import angular from 'angular';
import uiRouter from 'angular-ui-router';
import routing from './groupAttributeType.routes.js';
import GrpAtrTypeListCtrl from './list/list.controller.js';
import GrpAtrTypeViewCtrl from './view/view.controller.js';
import GrpAtrTypeFormCtrl from './form/form.controller.js';

export default angular.module('georgeApp.groupAttribute',
  [uiRouter])
  .config(routing)
  .controller('GrpAtrTypeListCtrl', GrpAtrTypeListCtrl)
  .controller('GrpAtrTypeViewCtrl', GrpAtrTypeViewCtrl)
  .controller('GrpAtrTypeFormCtrl', GrpAtrTypeFormCtrl)
  .name;
